export const pagesPlanningOperationsCoreEn = {
  releaseJudgement: {
    anchorDate: {
      missingTarget: 'No target production selected',
      missingTargetDescription: 'Go back and select a target production to judge.',
      pageTitle: 'Set the Judgement Date',
      start: 'Start',
      startFailed: 'Failed to start release judgement',
      startSuccess: 'Release judgement started'
    },
    instance: {
      approveAll: 'Approve all',
      approveAllSuccess: 'Approved all successfully',
      assignee: 'Assignee',
      backToCore: 'PN Operations Core',
      cannotApproveAll: 'Cannot approve all because there are no waiting approval tasks',
      progressTitle: 'Progress',
      requestedFor: 'Requested For'
    },
    list: {
      packageEmptyState: {
        description: 'The release judgement operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start release judgement operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Release Judgement',
      taskEmptyState: {
        description: 'Start a new release judgement and it will be listed here.',
        title: 'No release judgements yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Judgement Date',
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the PN Operations Core and start again.',
      pageTitle: 'Select a Target Production',
      searchPlaceholder: 'Search by production or product name'
    }
  },
  releasePlanCreation: {
    instance: {
      backToCore: 'PN Operations Core',
      data: {
        complete: 'Complete',
        noSelectTask: 'There is no target selection task to perform.',
        ticketColumns: {
          code: 'Code',
          kind: 'Type',
          priority: 'Priority',
          product: 'Product',
          status: 'Status',
          title: 'Title'
        },
        ticketSearchPlaceholder: 'Search by ticket title or code',
        ticketTaskName: 'Select target development tickets',
        toast: {
          ticketFailed: 'Failed to add target development tickets',
          ticketSuccess: 'Added target development tickets',
          ticketSuccessDetail: 'Added {{count}} development tickets.',
          valueFailed: 'Failed to add target values',
          valueSuccess: 'Added target values',
          valueSuccessDetail: 'Added {{count}} values.'
        },
        valueColumns: {
          code: 'No.',
          layer: 'Layer',
          targetBusiness: 'Target Business',
          targetUser: 'Target User',
          title: 'Title',
          valueType: 'Type'
        },
        valueSearchPlaceholder: 'Search by value title or code',
        valueTaskName: 'Select target values'
      },
      selectInDataTab: 'Select in the Data tab',
      selectInDataTabDescription: 'This task is completed by selecting targets in the Data tab.',
      tabs: {
        ariaLabel: 'Production plan creation tabs',
        data: 'Data',
        detail: 'Detail'
      }
    },
    list: {
      packageEmptyState: {
        description: 'The production plan creation operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start production plan creation operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Production Plan',
      taskEmptyState: {
        description: 'Create a new production plan and it will be listed here.',
        title: 'No production plans yet'
      }
    },
    plannedReleaseDate: {
      missingTarget: 'No target product selected',
      missingTargetDescription: 'Go back and select a target product.',
      pageTitle: 'Set the Planned Release Date',
      plannedDateLabel: 'Planned Release Date',
      start: 'Start',
      startFailed: 'Failed to start production plan creation',
      startSuccess: 'Production plan creation started'
    },
    targetSelection: {
      columns: {
        code: 'Code',
        latestRelease: 'Latest Release',
        productName: 'Product Name'
      },
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the PN Operations Core and start again.',
      pageTitle: 'Select a Target Product',
      searchPlaceholder: 'Search by product name or code'
    }
  },
  sidebar: {
    developmentTicketInventory: 'Development Ticket Inventory',
    releaseJudgement: 'Release Judgement',
    releasePlanCreation: 'Production Plan Creation',
    underDevelopment: 'This operation package is currently under development.'
  },
  ticketReconciliation: {
    anchorDate: {
      missingTarget: 'No target product selected',
      missingTargetDescription: 'Go back and select a target product.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start development ticket stocktaking',
      startSuccess: 'Development ticket stocktaking started'
    },
    instance: {
      data: {
        aiRecommended: 'AI Recommended',
        complete: 'Complete Ticket Organizing',
        completeSuccess: 'Ticket organizing completed',
        description: 'Review the development tickets linked to the target product. AI recommended candidates will be highlighted when available.',
        diff: {
          addedBadge: 'Proposed Addition',
          changedBadge: 'Proposed Change',
          field: {
            changeAreas: 'Change Areas',
            decisionNote: 'Decision Note',
            expectedOutcome: 'Expected Outcome',
            kind: 'Kind',
            priority: 'Priority',
            riskNote: 'Risk Note',
            severity: 'Severity',
            sprint: 'Sprint',
            status: 'Status',
            summary: 'Summary',
            title: 'Title'
          },
          removedBadge: 'Proposed Removal',
          summaryAdded: 'Added: {{count}}',
          summaryChanged: 'Changed: {{count}}',
          summaryRemoved: 'Removed: {{count}}',
          summaryTitle: 'AI Proposed Changes'
        },
        missingContext: 'Could not load the development ticket list',
        missingContextDescription: 'The target product for this instance could not be resolved.',
        noTask: 'No ticket organizing task is available',
        noTickets: 'No development tickets are linked to the target product',
        table: {
          headers: {
            code: 'No',
            kind: 'Kind',
            priority: 'Priority',
            severity: 'Severity',
            status: 'Status',
            title: 'Title'
          }
        },
        title: 'Development Ticket List'
      },
      detail: {
        assignInline: {
          assignSuccess: 'Assignee set',
          assigneeLabel: 'Assignee',
          assigneePlaceholder: 'Select an assignee',
          complete: 'Complete',
          loading: 'Loading assignee candidates…'
        }
      },
      organizeInDataTab: 'Review in the Data tab',
      organizeInDataTabDescription: 'Review the development ticket list and complete this task in the Data tab.'
    },
    list: {
      packageEmptyState: {
        description: 'The development ticket stocktaking operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start development ticket stocktaking operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Ticket Stocktaking',
      taskEmptyState: {
        description: 'Start a new development ticket stocktaking and it will be listed here.',
        title: 'No development ticket stocktaking yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the PN Operations Core and start again.',
      pageTitle: 'Select a Target Product',
      searchPlaceholder: 'Search by product name or code'
    }
  }
};